import { gql } from "@/services/httpAdapter";

const ActionFragment = gql`
	fragment AuthorizationAction on AuthorizationAction {
		_id
		actionDescription
		actionKey
		actionName
	}
`;

const GroupFragment = gql`
	fragment AuthorizationGroup on AuthorizationGroup {
		_id
		groupActions
		groupDescription
		groupName
		locationId
	}
`;

const addUserAuthorizationSubscription = gql`
	subscription onAddUserAuthorization($_id: String) {
		onAddUserAuthorization(_id: $_id) {
			_id
			auth {
				_id
				locationId
				actions {
					...AuthorizationAction
				}
				groups {
					...AuthorizationGroup
				}
			}
		}
	}
	${ActionFragment}
	${GroupFragment}
`;

const deleteUserAuthorizationSubscription = gql`
	subscription onDeleteUserAuthorization($_id: String) {
		onDeleteUserAuthorization(_id: $_id) {
			_id
			auth {
				_id
				locationId
				actions {
					...AuthorizationAction
				}
				groups {
					...AuthorizationGroup
				}
			}
		}
	}
	${ActionFragment}
	${GroupFragment}
`;

const addUserAuthorizationLocationSubscription = gql`
	subscription onAddUserAuthorizationLocation($_id: String) {
		onAddUserAuthorizationLocation(_id: $_id) {
			_id
			auth {
				_id
				locationId
				actions {
					...AuthorizationAction
				}
				groups {
					...AuthorizationGroup
				}
			}
		}
	}
	${ActionFragment}
	${GroupFragment}
`;

const deleteUserAuthorizationLocationSubscription = gql`
	subscription onDeleteUserAuthorizationLocation($_id: String) {
		onDeleteUserAuthorizationLocation(_id: $_id) {
			_id
			auth {
				_id
				locationId
				actions {
					...AuthorizationAction
				}
				groups {
					...AuthorizationGroup
				}
			}
		}
	}
	${ActionFragment}
	${GroupFragment}
`;

const deleteUserGroupSubscription = gql`
	subscription onDeleteUserGroup($locationId: String) {
		onDeleteUserGroup(locationId: $locationId) {
			_id
			locationId
			groupActions
		}
	}
`;

const groupAccessModificationsSubscription = gql`
	subscription onGroupAccessModifications($locationId: String) {
		onGroupAccessModifications(locationId: $locationId) {
			_id
			locationId
			actions {
				actionKey
			}
			users {
				_id
			}
		}
	}
`;

const updateUserProfilePictureSubscription = gql`
	subscription onUpdateUserProfilePicture($_id: String) {
		onUpdateUserProfilePicture(_id: $_id) {
			_id
			presignedProfilePicture
		}
	}
`;

export {
	addUserAuthorizationSubscription,
	deleteUserAuthorizationSubscription,
	addUserAuthorizationLocationSubscription,
	deleteUserAuthorizationLocationSubscription,
	deleteUserGroupSubscription,
	groupAccessModificationsSubscription,
	updateUserProfilePictureSubscription,
};
